// extracted by mini-css-extract-plugin
export var addressFields = "_mj-0";
export var animationContainer = "_mj-1";
export var footer = "_mj-2";
export var lineItems = "_mj-3";
export var modalContent = "_mj-4";
export var orderName = "_mj-5";
export var strong = "_mj-6";
export var warning = "_mj-7";